module.exports = __webpack_public_path__ + "static/media/profile resized.8589d227.png";